export const locales = ['fr', 'en', 'de', 'es', 'it', 'pt'] as const;
export type Locale = (typeof locales)[number];
/**
 * Locale servie quand la négociation n'aboutit pas : pas de préfixe dans l'URL,
 * pas de cookie, pas d'`Accept-Language` exploitable (cas Googlebot).
 *
 * `en` = lingua franca B2B voyage (décision SEO Lot 2). C'est la SOT unique :
 * `routing.defaultLocale`, `resolveRequestLocale` et `resolveLocale()` en
 * dérivent tous, sinon l'URL et l'API divergent en silence.
 *
 * ⚠️ Ce n'est PAS le repli d'affichage des dates : `date-fns-locale.ts` garde son
 * propre repli `fr`, qui est une décision produit distincte.
 */
export const defaultLocale: Locale = 'en';
